if (!customElements.get('ms-collection-description')) {
  customElements.define('ms-collection-description', class extends HTMLElement {
    connectedCallback() {
      const content = this.querySelector('.ms-collection-seo__text');
      const button = this.querySelector('button');
      const update = () => {
        if (button.getAttribute('aria-expanded') === 'true') return;
        content.classList.remove('is-collapsed');
        const needsToggle = content.scrollHeight > 360;
        button.hidden = !needsToggle;
        content.classList.toggle('is-collapsed', needsToggle);
      };
      button.addEventListener('click', () => {
        const expanded = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', expanded);
        button.firstChild.textContent = expanded ? button.dataset.collapse : button.dataset.expand;
        content.classList.toggle('is-collapsed', !expanded);
      });
      this.observer = new ResizeObserver(update);
      this.observer.observe(this);
      update();
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}

if (!customElements.get('ms-filter-search')) {
  customElements.define('ms-filter-search', class extends HTMLElement {
    connectedCallback() {
      const input = this.querySelector('input');
      input.addEventListener('change', event => event.stopPropagation());
      input.addEventListener('input', event => {
        event.stopPropagation();
        const query = input.value.trim().toLocaleLowerCase();
        this.parentElement.querySelectorAll('li').forEach(item => {
          item.hidden = !item.textContent.toLocaleLowerCase().includes(query);
          if (query) item.classList.remove('js-hidden');
        });
      });
    }
  });
}
